import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
import LaptopSearch from '@crehana/icons/pictograms/LaptopSearch';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors } from '@crehana/ui';

import { useAttributes } from '@/views/AdminDashboard/components/AttributesDrawer/hooks';

import AttributeList from './components/AttributeList';
import { AttrWrapper, BoxCount } from './Steps.styles';

const { grayMain, blueLighter } = colors;

interface Step3Props {
  isDark?: boolean;
}

const Step3: FC<React.PropsWithChildren<Step3Props>> = ({ isDark }) => {
  const { t } = useTranslation();
  const { attributes } = useAttributes();

  return (
    <>
      <section className="flex mb-12">
        <p className="font-subtitle3 mr-8">{t('ATTR_COUNT_LABEL')}</p>
        <BoxCount className="font-caption" isDark={isDark}>
          {attributes?.length || 0}
        </BoxCount>
      </section>
      <AttrWrapper isDark={isDark}>
        {attributes?.length === 0 ? (
          <>
            <LaptopSearch
              className="icon"
              color={isDark ? blueLighter : grayMain}
            />
            <p className="font-body4">{t('ATTR_COUNT_EMPTY')}</p>
          </>
        ) : (
          <div className="h-full w-full p-relative">
            <div className="flex flex-col w-full">
              {attributes.map(attribute => (
                <AttributeList
                  key={attribute.originalId}
                  attribute={attribute}
                  step={3}
                  isDark={isDark}
                />
              ))}
            </div>
          </div>
        )}
      </AttrWrapper>
    </>
  );
};

export default Step3;
